exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".livefeed-panel{margin-left:-20px}.livefeed-list .livefeed-item{border:none;background-color:#d9edf7;padding:15px;margin-bottom:10px;border-radius:4px;font-size:12px}.livefeed-list .livefeed-item .icon i{display:block;width:40px;height:40px;text-align:center;vertical-align:middle;line-height:40px;font-size:35px;color:#99cce3}.livefeed-list .livefeed-item .info{margin-left:56px;margin-top:-40px}.livefeed-list .livefeed-item .info span.highlighted{color:inherit}.livefeed-list .livefeed-item .info span:not(.highlighted){color:#999}.livefeed-enter{opacity:0}.livefeed-enter.livefeed-enter-active{opacity:1;transition:opacity 1s ease-in}.livefeed-leave{opacity:1}.livefeed-leave.livefeed-leave-active{opacity:.01;transition:opacity 1s ease-in}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/css/livefeed.less
 ** module id = 778
 ** module chunks = 0
 **/